import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Input } from 'reactstrap'

import style from '../../style'

export const EditTableRow = props => {
  const groupedContent = props.content.reduce((groups, item) => {
    groups[item.type] = [...(groups[item.type] || [])]
    groups[item.type].push(item)
    return groups
  }, {})

  return (
    <tr className={css(style.editable.wrapper)}>
      <td className={css(style.table.td)}>
        <span className={css(style.tableRow.title)}>{props.title}</span>
      </td>
      <td className={css(style.table.td)}>
        <form onSubmit={props.onFormSubmit}>
          <Row className={css(style.editable.hNotes)}>
            <Col>
              {(groupedContent.hNote || []).map((item, index) => (
                <p
                  key={`hp_${index}`}
                  className={css(style.editable.p)}
                  style={{ fontStyle: item.style || 'normal' }}
                >
                  {item.value}
                </p>
              ))}
            </Col>
          </Row>

          <Row>
            <Col>
              {(groupedContent.input || []).map((item, index) => (
                <RenderInput
                  key={index}
                  {...item}
                  onChange={props.onInputChange}
                />
              ))}
            </Col>
          </Row>

          <Row className={css(style.editable.bNotes)}>
            <Col>
              {(groupedContent.bNote || []).map((item, index) => (
                <p
                  key={`bp_${index}`}
                  className={css(style.editable.p)}
                  style={{ fontStyle: item.style || 'normal' }}
                >
                  {item.value}
                </p>
              ))}
            </Col>
          </Row>
          <Row>
            <Col xs='auto'>
              <input
                type={'submit'}
                value={'Save'}
                className={css(style.editable.button, style.editable.submit)}
              />
            </Col>
            <Col xs='auto'>
              <input
                type={'button'}
                value={'Cancel'}
                onClick={props.onCancelClick}
                className={css(style.editable.button)}
              />
            </Col>
          </Row>
        </form>
      </td>
      <td className={css(style.table.td)} />
    </tr>
  )
}

const RenderInput = props => {
  console.log(props)
  return (
    <Row>
      <Col
        xs='12'
        md='4'
        className={`d-flex align-items-center justify-content-end`}
      >
        <span className={css(style.editable.nameSpan)}>
          {props.label || props.name}
        </span>
      </Col>
      <Col>
        <Input
          key={`input_${props.name}`}
          name={props.name}
          onChange={props.onChange}
          value={props.value}
          className={css(style.editable.input)}
        />
      </Col>
    </Row>
  )
}

export default EditTableRow



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/partials/EditTableRow/index.js